import { ENV } from "./env";

type GTMUserPayload = {
  userEmail?: string;
  userId?: number | string;
  userRole?: string;
};

type DataLayerWindow = Window & {
  dataLayer?: Array<Record<string, unknown>>;
};

const getDataLayer = () => (window as DataLayerWindow).dataLayer;

export const rpGTM = {
  login: ({ userId, userEmail, userRole }: GTMUserPayload) => {
    const dataLayer = getDataLayer();

    if (ENV.GOOGLE_TAG_MANAGER_ID && dataLayer) {
      dataLayer.push({
        event: "login",
        userId: userId,
        userEmail: userEmail,
        userRole: userRole,
        time: new Date().toISOString(),
      });
    }
  },
  logout: () => {
    const dataLayer = getDataLayer();

    if (ENV.GOOGLE_TAG_MANAGER_ID && dataLayer) {
      dataLayer.push({
        event: "logout",
        time: new Date().toISOString(),
      });
    }
  },
  setUserDetails: ({ userId, userEmail, userRole }: GTMUserPayload) => {
    const dataLayer = getDataLayer();

    if (ENV.GOOGLE_TAG_MANAGER_ID && dataLayer) {
      dataLayer.push({
        event: "user_details",
        userId: userId,
        userEmail: userEmail,
        userRole: userRole,
        time: new Date().toISOString(),
      });
    }
  },
};
